module.exports = __webpack_public_path__ + "img/concrete-hole-decal-18.f938facd.png";